import { useMemo } from 'react'
import { UserInfo, useUserInfo } from './useUserInfo'
import { isStringNotEmpty, IsVarEmpty } from '../../NonReact/utils/GlobalFunctions'
import { PIPE } from '../../React/Common/Constants/Separators'
import { AdminBackendPermissionNames } from '../../React/Common/Constants/Permissions'

export type UserPermissions = {
    Read: boolean
    Create: boolean
    Delete: boolean
    Update: boolean
}

const USER_PERMISSIONS_ALL_FALSE: UserPermissions = {
    Read: false,
    Create: false,
    Delete: false,
    Update: false
}

const USER_PERMISSIONS_ALL_TRUE: UserPermissions = {
    Read: true,
    Create: true,
    Delete: true,
    Update: true
}

export const usePermissions = (permissionName?: AdminBackendPermissionNames): UserPermissions => {
    const [userInfo]: UserInfo = useUserInfo()

    return useMemo((): UserPermissions => {
        if (IsVarEmpty(userInfo)) {
            return USER_PERMISSIONS_ALL_FALSE
        }

        return isStringNotEmpty(permissionName)
            ? userInfo?.Permissions?.Admin?.filter((adminPermission: string): boolean =>
                  adminPermission.startsWith(permissionName)
              )?.reduce((acc: UserPermissions, permission: string): UserPermissions => {
                  const permissionType: string = permission.split(PIPE)[1]

                  acc[permissionType as keyof UserPermissions] = true

                  return acc
              }, USER_PERMISSIONS_ALL_FALSE) ?? USER_PERMISSIONS_ALL_TRUE
            : USER_PERMISSIONS_ALL_TRUE
    }, [userInfo])
}
